<template>
  <div class="hr-company-name" :title="`${t('hrDashboard.companyLabel')}: ${name}`">
    <v-icon size="18" class="hr-company-name__icon">mdi-domain</v-icon>
    <span class="hr-company-name__text text-h6">{{ name }}</span>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

// Numele companiei tenantului în antetul HR Dashboard, în locul selectorului (rezervat adminului platformei).
defineProps({ name: { type: String, required: true } });
const { t } = useI18n();
</script>

<style scoped>
.hr-company-name {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
  max-width: 50%;
  flex-shrink: 0;
}

.hr-company-name__icon {
  flex-shrink: 0;
  color: rgb(var(--v-theme-tertiary));
}

.hr-company-name__text {
  color: var(--app-text-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 960px) {
  .hr-company-name {
    max-width: 100%;
    justify-content: flex-start;
  }
}
</style>
